export const inventoryproductsdata = [
  {
    id: 1,
    pdv : "HOOKER",
    product: "BABA OSMAN AMANDE",
    productImage: "assets/img/products/OSAM.jpg",
    sku: "OSAM",
    group: "DOUCEUR TRADITIONNELLE",
    model: "AMANDE",
    maker: "BR55",
    purchase_unit_price_ht: "25.000 TND",
    purchase_unit: "KG",
    sales_unit: ["KG","PCS"],
    values_sales_unit :[1,100],
    sales_unit_price_ht : "76.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 3,
    validity_period_in_hours : 24,
    qte_th :15,
    qte_r : 14,
    production_date : "2025-07-01"
  }, 
  {
    id: 101,
    pdv : "BRAZIL",
    product: "BABA OSMAN AMANDE",
    productImage: "assets/img/products/OSAM.jpg",
    sku: "OSAM",
    group: "DOUCEUR TRADITIONNELLE",
    model: "AMANDE",
    maker: "BR55",
    purchase_unit_price_ht: "25.000 TND",
    purchase_unit: "KG",
    sales_unit: ["KG","PCS"],
    values_sales_unit :[1,100],
    sales_unit_price_ht : "76.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 3,
    validity_period_in_hours : 24,
    qte_th :10,
    qte_r : 10,
    production_date : "2025-07-12"
  }, 
  {
    id: 9,
    pdv : "HOOKER",
    product: "ELEGANCE 16",
    productImage: "assets/img/products/EGAS.jpg",
    sku: "EGAS",
    group: "COFFRET ELEGANCE",
    model: "AMANDE",
    maker: "MR15",
    purchase_unit_price_ht: "21.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PCS"],
    values_sales_unit :[16],
    sales_unit_price_ht : "32.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : true,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 3,
    validity_period_in_hours : 350,
    qte_th :200,
    qte_r : 210,
    production_date : "2025-07-23"
  },
  {
    id: 900,
    pdv : "BRAZIL",
    product: "ELEGANCE 16",
    productImage: "assets/img/products/EGAS.jpg",
    sku: "EGAS",
    group: "COFFRET ELEGANCE",
    model: "AMANDE",
    maker: "MR15",
    purchase_unit_price_ht: "21.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PCS"],
    values_sales_unit :[16],
    sales_unit_price_ht : "32.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : true,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 3,
    validity_period_in_hours : 350,
    qte_th :10,
    qte_r : 9,
    production_date : "2025-07-20"
  },
  {
    id: 2,
    pdv : "BRAZIL",
    product: "Farine",
    productImage: "assets/img/products/farine-patissiere.webp",
    sku: "FARI",
    group: "",
    model: "",
    maker: "",
    purchase_unit_price_ht: "1.500 TND",
    purchase_unit: "KG",
    sales_unit: [],
    values_sales_unit :[],
    sales_unit_price_ht : "",
    tax : "19%",
    type : "RawMaterial",
    IsComposed : false,
    IsPerishable : false,
    IsPrintable : false,
    Active : true,
    product_display_order : 1,
    validity_period_in_hours : 0,
    qte_th :20,
    qte_r : 20,
    production_date : "2025-07-18"
  },
  {
    id: 20,
    pdv : "HOOKER",
    product: "Farine",
    productImage: "assets/img/products/farine-patissiere.webp",
    sku: "FARI",
    group: "",
    model: "",
    maker: "",
    purchase_unit_price_ht: "1.500 TND",
    purchase_unit: "KG",
    sales_unit: [],
    values_sales_unit :[],
    sales_unit_price_ht : "",
    tax : "19%",
    type : "RawMaterial",
    IsComposed : false,
    IsPerishable : false,
    IsPrintable : false,
    Active : true,
    product_display_order : 1,
    validity_period_in_hours : 0,
    qte_th :30,
    qte_r : 0,
    production_date : "2025-07-18"
  },
  {
    id: 3,
    pdv : "BRAZIL",
    product: "Huile",
    productImage: "assets/img/products/huile-de-friture.jpg",
    sku: "HUI1",
    group: "",
    model: "",
    maker: "",
    purchase_unit_price_ht: 23,
    purchase_unit: "L",
    sales_unit: [],
    values_sales_unit :[],
    sales_unit_price_ht : "",
    tax : "19%",
    type : "RawMaterial",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : false,
    Active : true,
     product_display_order : 2,
    validity_period_in_hours : 800,
    qte_th :8,
    qte_r : 3,
    production_date : "2025-07-18"
  },
 
  {
    id: 4,
    pdv : "BRAZIL",
    product: "BAKLAWA PISTACHE ",
    productImage: "assets/img/products/BKPS.jpg",
    sku: "BKPS",
    group: "DOUCEUR TRADITIONNELLE",
    model: "PISTACHE",
    maker: "MR15",
    purchase_unit_price_ht: "40.000 TND",
    purchase_unit: "KG",
    sales_unit: ["KG","PCS"],
    values_sales_unit :[1,50],
    sales_unit_price_ht : "109.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 1,
    validity_period_in_hours : 800,
    qte_th :8,
    qte_r : 0,
    production_date : "2025-07-18"
  },
  {
    id: 5,
    pdv : "BRAZIL",
    product: "DANOUNI VIANDE",
    productImage: "assets/img/products/DAVI.jpg",
    sku: "DAVI",
    group: "SALÉ VIANDE",
    model: "SALÉ CHAUD",
    maker: "MR15",
    purchase_unit_price_ht: "29.000 TND",
    purchase_unit: "KG",
    sales_unit: ["KG","PCS"],
    values_sales_unit :[1,40],
    sales_unit_price_ht : "68.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 2,
    validity_period_in_hours : 48,
    qte_th :5,
    qte_r : 0,
    production_date : "2025-07-18"
  },
  {
    id: 10,
    pdv : "BRAZIL",
    product: "ELEGANCE 22",
    productImage: "assets/img/products/EGAS.jpg",
    sku: "EGAS",
    group: "COFFRET ELEGANCE",
    model: "AMANDE",
    maker: "MR15",
    purchase_unit_price_ht: "26.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PCS"],
    values_sales_unit :[22],
    sales_unit_price_ht : "41.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : true,
    IsPerishable : true,
    IsPrintable : false,
    Active : false,
    product_display_order : 4,
    validity_period_in_hours : 36,
    qte_th :0,
    qte_r : 0,
    production_date : "2025-07-19"
  },
  {
    id: 6,
    pdv : "BRAZIL",
    product: "BOURGEOISE 2",
    productImage: "assets/img/products/BOU2.jpg",
    sku: "BOU2",
    group: "GATEAUX A PARTAGER",
    model: "GATEAUX",
    maker: "BV20",
    purchase_unit_price_ht: "39.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PAX"],
    values_sales_unit :[10],
    sales_unit_price_ht : "90.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 5,
    validity_period_in_hours : 20,
    qte_th :3,
    qte_r : "",
    production_date : "2025-07-25"
  },
  {
    id: 7,
    pdv : "BRAZIL",
    product: "Sucre",
    productImage: "assets/img/products/SucreGlace.jpg.webp",
    sku: "SUC1",
    group: "",
    model: "",
    maker: "",
    purchase_unit_price_ht: 2,
    purchase_unit: "KG",
    sales_unit: [],
    values_sales_unit :[],
    sales_unit_price_ht : "",
    tax : "19%",
    type : "RawMaterial",
    IsComposed : false,
    IsPerishable : false,
    IsPrintable : false,
    Active : true,
    product_display_order : 3,
    validity_period_in_hours : 5000,
    qte_th :1,
    qte_r : "",
    production_date : "2025-07-23"
  },
  {
    id: 8,
    pdv : "BRAZIL",
    product: "PRESTIGE 25",
    productImage: "assets/img/products/EIPM.jpg",
    sku: "EIPM",
    group: "COFFRET PRESTIGE",
    model: "PISTACHE",
    maker: "BV20",
    purchase_unit_price_ht: "75.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PAX"],
    values_sales_unit :[10],
    sales_unit_price_ht : "90.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : true,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 9,
    validity_period_in_hours : 200,
    qte_th :9,
    qte_r : null,
    production_date : "2025-07-23"
  },
 
  {
    id: 32,
    pdv : "HOOKER",
    product: "Huile",
    productImage: "assets/img/products/huile-de-friture.jpg",
    sku: "HUI1",
    group: "",
    model: "",
    maker: "",
    purchase_unit_price_ht: 23,
    purchase_unit: "L",
    sales_unit: [],
    values_sales_unit :[],
    sales_unit_price_ht : "",
    tax : "19%",
    type : "RawMaterial",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : false,
    Active : true,
     product_display_order : 2,
    validity_period_in_hours : 800,
    qte_th :4,
    qte_r : 0,
    production_date : "2025-07-24"
  },
 
  {
    id: 44,
    pdv : "HOOKER",
    product: "BAKLAWA PISTACHE ",
    productImage: "assets/img/products/BKPS.jpg",
    sku: "BKPS",
    group: "DOUCEUR TRADITIONNELLE",
    model: "PISTACHE",
    maker: "MR15",
    purchase_unit_price_ht: "40.000 TND",
    purchase_unit: "KG",
    sales_unit: ["KG","PCS"],
    values_sales_unit :[1,50],
    sales_unit_price_ht : "109.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 1,
    validity_period_in_hours : 800,
    qte_th :18,
    qte_r : 16,
    production_date : "2025-07-26"
  },
  {
    id: 55,
    pdv : "HOOKER",
    product: "DANOUNI VIANDE",
    productImage: "assets/img/products/DAVI.jpg",
    sku: "DAVI",
    group: "SALÉ VIANDE",
    model: "SALÉ CHAUD",
    maker: "MR15",
    purchase_unit_price_ht: "29.000 TND",
    purchase_unit: "KG",
    sales_unit: ["KG","PCS"],
    values_sales_unit :[1,40],
    sales_unit_price_ht : "68.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 2,
    validity_period_in_hours : 48,
    qte_th :18,
    qte_r : 18,
    production_date : "2025-07-24"
  },
  {
    id: 1011,
    pdv : "HOOKER",
    product: "ELEGANCE 22",
    productImage: "assets/img/products/EGAS.jpg",
    sku: "EGAS",
    group: "COFFRET ELEGANCE",
    model: "AMANDE",
    maker: "MR15",
    purchase_unit_price_ht: "26.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PCS"],
    values_sales_unit :[22],
    sales_unit_price_ht : "41.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : true,
    IsPerishable : true,
    IsPrintable : false,
    Active : false,
    product_display_order : 4,
    validity_period_in_hours : 36,
    qte_th :0,
    qte_r : 0,
    production_date : "2025-07-24"
  },
  {
    id: 602,
    pdv : "HOOKER",
    product: "BOURGEOISE 2",
    productImage: "assets/img/products/BOU2.jpg",
    sku: "BOU2",
    group: "GATEAUX A PARTAGER",
    model: "GATEAUX",
    maker: "BV20",
    purchase_unit_price_ht: "39.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PAX"],
    values_sales_unit :[10],
    sales_unit_price_ht : "90.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : false,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 5,
    validity_period_in_hours : 20,
    qte_th :18,
    qte_r : 22,
    production_date : "2025-07-24"
  },
  {
    id: 709,
    pdv : "HOOKER",
    product: "Sucre",
    productImage: "assets/img/products/SucreGlace.jpg.webp",
    sku: "SUC1",
    group: "",
    model: "",
    maker: "",
    purchase_unit_price_ht: 2,
    purchase_unit: "KG",
    sales_unit: [],
    values_sales_unit :[],
    sales_unit_price_ht : "",
    tax : "19%",
    type : "RawMaterial",
    IsComposed : false,
    IsPerishable : false,
    IsPrintable : false,
    Active : true,
    product_display_order : 3,
    validity_period_in_hours : 5000,
    qte_th :18,
    qte_r : 17.8,
    production_date : "2025-07-24"
  },
  {
    id: 816,
    pdv : "HOOKER",
    product: "PRESTIGE 25",
    productImage: "assets/img/products/EIPM.jpg",
    sku: "EIPM",
    group: "COFFRET PRESTIGE",
    model: "PISTACHE",
    maker: "BV20",
    purchase_unit_price_ht: "75.000 TND",
    purchase_unit: "PCS",
    sales_unit: ["PAX"],
    values_sales_unit :[10],
    sales_unit_price_ht : "90.000 TND",
    tax : "19%",
    type : "Finished",
    IsComposed : true,
    IsPerishable : true,
    IsPrintable : true,
    Active : true,
    product_display_order : 9,
    validity_period_in_hours : 200,
    qte_th :5,
    qte_r : 5.5,
    production_date : "2025-07-24"
  },
  
];
